export const defaultPropertyProfileExportOptions = {
  isReportExportDetailsAndCharacteristicsVisible: true,
  isReportExportPlatMapVisible: true,
  isReportExportSaleInformationVisible: true,
  isReportExportSchoolsVisible: true,
  isReportExportTransactionHistoryVisible: true
};
